import { Routes } from '@angular/router';
import { notificationGuard } from './features/notifications/notification.routes';
import { RoleGuard } from './core/auth/guards/role.guard';
//superadmin
import { NoAuthGuard } from './core/auth/guards/guest.guard';
import { HomeRedirectGuard } from './core/auth/guards/home-redirect.guard';
export const routes: Routes = [
  {
    path: 'notifications',
    canMatch: [notificationGuard],
    loadChildren: () => import('./features/notifications/notification.routes').then(m => m.notificationRoutes),
  },
  //salarie
  {
    path: 'salarie',
    canMatch: [RoleGuard],
    data: {
      profiles: ['SALARIE', 'ADMIN_ENTREPRISE'],
      breadcrumb: 'Espace salarié',
    },
    loadChildren: () =>
      import('./features/salarie/salarie.routes').then(
        (m) => m.salarieRoutes,
      ),
  },
  //Admin
  {
    path: 'admin-entreprise',
    loadChildren: () =>
      import('./features/admin/admin.routes').then((m) => m.adminRoutes),
  },
  //Super admin
  {
    path: 'admin-global',
    canMatch: [RoleGuard],
    data: { profiles: ['SUPER_ADMIN'] },
    loadChildren: () =>
      import('./features/super-admin/super-admin.routes').then(
        (m) => m.superAdminRoutes,
      ),
  },
  {
    path: 'login',
    canMatch: [NoAuthGuard],
    loadComponent: () =>
      import('./features/auth/login/login.page').then((c) => c.LoginPage),
  },
  {
    path: 'reset-password',
    canMatch: [NoAuthGuard],
    loadComponent: () =>
      import('./features/auth/reset-password/reset-password.page').then(
        (c) => c.ResetPasswordPage,
      ),
  },
  {
    path: '',
    canMatch: [HomeRedirectGuard],
    loadComponent: () =>
      import('./features/external/external.page').then(c => c.ExternalPage),
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./features/external/external.routes').then(
            m => m.EXTERNAL_ROUTES
          )
      }
    ]
  }
];
